import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const CloseIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M18 6L6.00081 17.9992M17.9992 18L6 6.00085" stroke="currentColor" />
    </SvgIcon>
  )
}
